import React from 'react';
import { Box, Typography } from '@mui/material';

const SystemSettingsTab: React.FC = () => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        System Settings
      </Typography>
      <Typography>Configure global system parameters and API integrations here.</Typography>
    </Box>
  );
};

export default SystemSettingsTab;
